module.exports = __webpack_public_path__ + "static/media/notice-icon.2803ed21.svg";